import { Box, Button } from "@skailer-com/uikit";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export const RevealBlock = ({ children }: { children: React.ReactNode }) => {
  const [revealed, setRevealed] = React.useState(false);
  const { t } = useTranslation();
  return (
    <div className="pb-(--gap-xl)">
      {!revealed && (
        <Button variant={"secondary"} onClick={() => setRevealed(true)}>
          {t("core:find_out_more")}
        </Button>
      )}
      {revealed && (
        <Box variant={"darkRounded"} className="mt-3">
          {children}
        </Box>
      )}
    </div>
  );
};

export const ImageWrapper: React.FC<{ src: string; alt: string; caption?: string }> = ({
  src,
  alt,
}) => {
  return (
    <span className={twMerge("w-full bg-dark/5 rounded-md flex items-center", "p-8")}>
      <span className={"shadow-md rounded-sm border border-light mx-auto"}>
        <img src={src} alt={alt} className="object-cover rounded-sm" />
      </span>
    </span>
  );
};

export const LinkWrapper: React.FC<{ href?: string; children: React.ReactNode }> = ({
  href,
  children,
}) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href && (href.startsWith("/") || href.startsWith("#"))) {
      e.preventDefault();
      navigate(href);
    }
  };

  return (
    <a href={href} onClick={handleClick}>
      {children}
    </a>
  );
};
